import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../../assets/images/Logo.png";
import clsx from "clsx";

const Navbar = () => {
  const TOP_OFFSET = 50;
  const [showBackgroundNavbar, setShowBackgroundNavbar] =
    useState<boolean>(false);
  const [showMobileMenu, setShowMobileMenu] = useState<boolean>(false);
  const { pathname } = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= TOP_OFFSET) {
        setShowBackgroundNavbar(true);
      } else {
        setShowBackgroundNavbar(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setShowMobileMenu(false);
  }, [pathname]);

  const handleUnderlineNav = (path: string): string => {
    if (path === pathname) {
      return "underline underline-offset-4";
    } else {
      return "";
    }
  };

  return (
    <nav
      className={`${pathname === "/enel" ? "hidden" : "fixed"} ${pathname === "/enel/" ? "hidden" : "fixed"} ${pathname === "/icali" ? "hidden" : "fixed"} z-30 w-full ${showBackgroundNavbar ? "bg-white" : "bg-transparent"} ${pathname === "/terminos-y-condiciones" || pathname === "/politica-datos" ? "hidden" : ""}`}
    >
      <div className="max-w-screen flex">
        <div className="flex w-full items-center justify-between px-5 lg:justify-end lg:px-0 xl:w-1/6 2xl:w-1/6">
          <Link to="/">
            <div className="h-20 w-20 pt-2 lg:h-20 lg:w-20 xl:h-28 xl:w-24">
              <img alt="acinco_logo" src={Logo} />
            </div>
          </Link>
          <button
            type="button"
            className="text-gray-500 hover:bg-gray-100 focus:ring-gray-200 focus:ring-gray-200 h-12 w-12 items-center justify-center rounded-lg p-2 text-sm focus:outline-none focus:ring-2 lg:hidden"
            onClick={() => setShowMobileMenu((prevState) => !prevState)}
          >
            <svg
              style={{ marginTop: 0, width: "100%" }}
              width="25"
              viewBox="0 0 20 20"
            >
              <path
                fill="#003272"
                d="M 19.9876 1.998 L -0.0108 1.998 L -0.0108 -0.0019 L 19.9876 -0.0019 L 19.9876 1.998 Z"
              ></path>
              <path
                fill="#003272"
                d="M 19.9876 7.9979 L -0.0108 7.9979 L -0.0108 5.9979 L 19.9876 5.9979 L 19.9876 7.9979 Z"
              ></path>
              <path
                fill="#003272"
                d="M 19.9876 13.9977 L -0.0108 13.9977 L -0.0108 11.9978 L 19.9876 11.9978 L 19.9876 13.9977 Z"
              ></path>
              <path
                fill="#003272"
                d="M 19.9876 19.9976 L -0.0108 19.9976 L -0.0108 17.9976 L 19.9876 17.9976 L 19.9876 19.9976 Z"
              ></path>
            </svg>
          </button>
        </div>
        <div
          className={`${showMobileMenu ? "absolute left-1/3 z-50 my-10 mb-5 mt-20 w-2/3 items-center justify-center rounded-md bg-white lg:mt-10" : "hidden"} mb-5 lg:mt-10 lg:block lg:w-5/6 lg:justify-center xl:flex xl:w-5/6 2xl:w-5/6`}
        >
          <div className="lg:w-1/2">
            <ul className="my-5 flex flex-col items-center justify-center px-10 lg:my-0 lg:flex-row lg:justify-between xl:px-0 2xl:justify-evenly">
              <li
                className={clsx([
                  "my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0",
                  handleUnderlineNav("/"),
                ])}
              >
                <Link to="/">La Solución</Link>
              </li>
              <li
                className={clsx([
                  "my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0",
                  handleUnderlineNav("/productos"),
                ])}
              >
                <Link to="/productos">Servicios</Link>
              </li>
              <li
                className={clsx([
                  "my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0",
                  handleUnderlineNav("/clausulados"),
                ])}
              >
                <Link to="/clausulados">Clausulados</Link>
              </li>
              <li
                className={clsx([
                  "my-5 mt-1 hover:underline hover:underline-offset-4 lg:my-0",
                  handleUnderlineNav("/nosotros"),
                ])}
              >
                <Link to="/nosotros">Nosotros</Link>
              </li>
              <li className="h-9 rounded-lg bg-buttonPrimary px-3 py-1 font-bold text-white">
                <Link to="/tramites-y-reclamaciones">Reclamaciones</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default Navbar;
